export default [
    {
        path: 'chat',
        component: require('./Read').default,
        meta: { middleware: 'auth', controller: 'ChatController' }
    },
    {
        path: 'suportes',
        component: require('./ReadSuporte').default,
        meta: { middleware: 'auth', controller: 'SuporteController' }
    }, {
        path: 'demandas',
        component: require('./ReadDemanda').default,
        meta: { middleware: 'auth', controller: 'DemandaController' }
    },

];


